"use strict";
// Replaces src/renderer/src/util/webpack-hacks.ts in the web build.
// __non_webpack_require__ does not exist in a browser; dynamic (user
// installed / game) extensions are fused off.
module.exports = {
    webpackRequireHack: (id) => {
        throw new Error(`dynamic require('${id}') is fused off in the web build (dynamic extensions are not supported)`);
    },
    getRealNodeModulePaths: () => [],
};
